import { Box } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import React from 'react';
import JSONInput from 'react-json-editor-ajrm';
import { PrimaryButton } from '../../components/AtomComponents';
import { localeEn } from '../ConfigTenant/ConfigTenant';
import { Wait } from '../SchemaSync/SchemaSync';
import { useSchemaUploadV3 } from './useSchemaUploadV3';
import { SchemaUploadV3Form } from './SchemaUploadV3Form';

interface IProps {
  syncFor: string;
  messagesSet: any;
}

export const SchemaUploadV3 = ({ syncFor, messagesSet }: IProps) => {
  const {
    fileState,
    setFile,
    release,
    setRelease,
    type,
    setType,
    tenantId,
    setTenantId,
    processState,
    previewState,
    restart,
    handleUploadClick,
  } = useSchemaUploadV3({ syncFor, messagesSet });

  return (
    <Box>
      {processState === 0 && (
        <SchemaUploadV3Form
          fileProps={{ fileState, setFile }}
          formValues={{ release, setRelease, type, setType, tenantId, setTenantId }}
          onUploadClick={handleUploadClick}
        />
      )}

      {processState === 1 && <Wait />}

      {processState === 2 && (
        <>
          <div className="margin-bottom-3">
            <JSONInput
              id={`${syncFor}-manual-v3-jsonEditor`}
              theme="light_mitsuketa_tribute"
              locale={localeEn}
              placeholder={previewState}
              height="550px"
              width="100%"
              viewOnly={true}
              style={{ body: { fontSize: "16px" } }}
            />
          </div>
          <Alert severity="success" className="margin-bottom-3">
            Schema Uploaded successfully!
          </Alert>
          <PrimaryButton onClick={restart}>Restart</PrimaryButton>
        </>
      )}
    </Box>
  );
};
